import store from "@/redux/store";
import { SyntheticEvent } from 'react';

export const CHECK_ABILITY_EVENT = "check_ability_event";

export function checkAbility(view, ability, checkAll = true) {
    const abilities = store.getState()?.AuthReducer?.user_abilities?.abilities;
    if(abilities["**"]) {
        return true;
    } else if(ability != "**" && abilities["*"]) {
        return true;
    }

    if(abilities && abilities[view] != 'undefined' && typeof abilities[view] === 'object') {
        if(checkAll && (abilities[view]['*'] != undefined || abilities[view][ability] != undefined)) {
            return true;
        } else if(!checkAll && (abilities[view][ability] != undefined)) {
            return true;
        }
    }
    return false;

}

/*
export function checkAbility(view, ability) {
  const event = new SyntheticEvent(CHECK_ABILITY_EVENT, {
    bubbles: true,
    cancelable: true,
  });
  event.data = {view:view, ability:ability};
  window.dispatchEvent(event);
}

window.onload = function()
{
 if (window.addEventListener)
 {
  window.addEventListener(CHECK_ABILITY_EVENT, doSomething, false);
 }
 else if(window.attachEvent)
 {
  window.attachEvent(CHECK_ABILITY_EVENT, doSomething);
 }
}
*/